import { render, staticRenderFns } from "./Xultophy.vue?vue&type=template&id=59175a2c&scoped=true&"
import script from "./Xultophy.vue?vue&type=script&lang=js&"
export * from "./Xultophy.vue?vue&type=script&lang=js&"
import style0 from "./Xultophy.vue?vue&type=style&index=0&id=59175a2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59175a2c",
  null
  
)

export default component.exports